/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteScopeIssuesQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteScopeIssuesQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly scopeIssues: ReadonlyArray<{ readonly __typename?: 'WebsiteScopeIssues', readonly name: string, readonly health: number, readonly issueCategories: ReadonlyArray<{ readonly __typename?: 'WebsiteIssueCategory', readonly configuration: Record<string, any>, readonly defaultConfiguration: Record<string, any>, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueCategoryState, readonly affectedPagesPerState: { readonly __typename?: 'WebsiteIssueAffectedPagesPerState', readonly absoluteNumberOfPages: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStateAbsoluteNumberOfPages', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number }, readonly percentage: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStatePercentage', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number } } | null, readonly issues: ReadonlyArray<{ readonly __typename?: 'WebsiteIssue', readonly configuration: Record<string, any>, readonly context: any | null, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly isPresentable: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueState, readonly affectedPagesPerState: { readonly __typename?: 'WebsiteIssueAffectedPagesPerState', readonly absoluteNumberOfPages: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStateAbsoluteNumberOfPages', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number }, readonly percentage: { readonly __typename?: 'WebsiteIssueAffectedPagesPerStatePercentage', readonly closed: number, readonly ignored: number, readonly notApplicable: number, readonly notRequired: number, readonly open: number, readonly unknown: number } } | null, readonly ignoringRuleOnCases: { readonly __typename?: 'PageIssueIgnoringRuleOnCases', readonly id: CK.ID, readonly ignoredCases: ReadonlyArray<any>, readonly isEffective: boolean } | null, readonly ignoringRuleOnPages: { readonly __typename?: 'PageIssueIgnoringRuleOnPages', readonly id: CK.ID, readonly ignoredPageLegacyIds: ReadonlyArray<number>, readonly isEffective: boolean } | null, readonly ignoringRuleOnSegments: { readonly __typename?: 'PageIssueIgnoringRuleOnSegments', readonly id: CK.ID, readonly ignoredSegments: ReadonlyArray<string>, readonly isEffective: boolean } | null, readonly ignoringRuleOnWebsite: { readonly __typename?: 'IssueIgnoringRuleOnWebsite', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean } }> }> }> } | null };


export const WebsiteScopeIssuesDocument = gql`
    query WebsiteScopeIssues($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    scopeIssues {
      issueCategories {
        affectedPagesPerState {
          absoluteNumberOfPages {
            closed
            ignored
            notApplicable
            notRequired
            open
            unknown
          }
          percentage {
            closed
            ignored
            notApplicable
            notRequired
            open
            unknown
          }
        }
        configuration
        defaultConfiguration
        isActionable
        isConfigurationModified
        isIgnored
        issues {
          affectedPagesPerState {
            absoluteNumberOfPages {
              closed
              ignored
              notApplicable
              notRequired
              open
              unknown
            }
            percentage {
              closed
              ignored
              notApplicable
              notRequired
              open
              unknown
            }
          }
          configuration
          context
          ignoringRuleOnCases {
            id
            ignoredCases
            isEffective
          }
          ignoringRuleOnPages {
            id
            ignoredPageLegacyIds
            isEffective
          }
          ignoringRuleOnSegments {
            id
            ignoredSegments
            isEffective
          }
          ignoringRuleOnWebsite {
            id
            isActive
            isEffective
          }
          isActionable
          isConfigurationModified
          isIgnored
          isPresentable
          name
          pointsGained
          pointsToGain
          state
        }
        name
        pointsGained
        pointsToGain
        state
      }
      name
      health
    }
  }
}
    `;

/**
 * __useWebsiteScopeIssuesQuery__
 *
 * To run a query within a React component, call `useWebsiteScopeIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteScopeIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteScopeIssuesQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteScopeIssuesQuery(baseOptions: Apollo.QueryHookOptions<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables> & ({ variables: WebsiteScopeIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables>(WebsiteScopeIssuesDocument, options);
      }
export function useWebsiteScopeIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables>(WebsiteScopeIssuesDocument, options);
        }
export function useWebsiteScopeIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables>(WebsiteScopeIssuesDocument, options);
        }
export type WebsiteScopeIssuesQueryHookResult = ReturnType<typeof useWebsiteScopeIssuesQuery>;
export type WebsiteScopeIssuesLazyQueryHookResult = ReturnType<typeof useWebsiteScopeIssuesLazyQuery>;
export type WebsiteScopeIssuesSuspenseQueryHookResult = ReturnType<typeof useWebsiteScopeIssuesSuspenseQuery>;
export type WebsiteScopeIssuesQueryResult = Apollo.QueryResult<WebsiteScopeIssuesQuery, WebsiteScopeIssuesQueryVariables>;